var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-sql-builder',{attrs:{"sql_json":_vm.sqlBuilder}})}
var staticRenderFns = []

export { render, staticRenderFns }